import React from "react";
import { FontIcon } from "@fluentui/react/lib/components/Icon/FontIcon";
import { classNames } from "maven-lib/dist/utils/misc";
import { IconName, IconPackageName } from "../interface/Icon";

interface CrIconProps {
  icon: IconName | IconPackageName;
  ariaLabel?: string;
  className?: string;
}

export function CrIcon(props: CrIconProps) {
  const { icon, ariaLabel, className } = props;

  return (
    <>
      {(typeof icon === "string" || icon.package === "FLUENT") && (
        <FontIcon
          iconName={typeof icon === "string" ? icon : icon.name}
          aria-label={ariaLabel}
          className={classNames("cr-icon", className, "--fluent", `--icon-${typeof icon === "string" ? icon : icon.name}`)}
        />
      )}
      {typeof icon === "object" && icon.package === "MATERIAL" && (
        <i className={classNames("cr-icon", "--material", "notranslate", `--icon-${icon.name}`, className)}>{icon.name}</i>
      )}
    </>
  );
}
